<template>
    <div id="portfolio">
        <section class="section section-padding">
            <div class="container">
                <div class="section-heading mb-0">
                    <span class="subtitle primary">Nuestra cartera.</span>
                    <h2 class="font-weight-100">
                        Rendimientos <span class="bold">estables</span>
                        y <span class="bold">superiores</span> a lo tradicional.
                    </h2>
                    <div class="row">
                        <div class="col-lg-12" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                            <div class="row">
                                <div class="offset-lg-1 col-lg-5 col-sm-12">
                                    <div id="chart">
                                        <VueApexCharts v-if="isMounted && getSeries.length > 0" type="bar" height="450" :options="chartOptions" :series="getSeries">
                                        </VueApexCharts>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-sm-12 align-initial">
                                    <h1 class="primary font-weight-100 mb-0">RedGirasol <span class="bold"> {{ isMounted ? (rgStats.net_yield.toFixed(2) || 0) : "--" }}%</span><sup>1</sup></h1>
                                    <h1 class="black font-weight-100 mb-0">CETES <span class="bold"> {{ isMounted ?  (rgStats.cetes.toFixed(2) || 0)  : "--" }}%</span><sup>2</sup></h1>
                                    <!-- <h1 class="black font-weight-100 mb-0">CETES <span class="bold"> 10.25%</span><sup>2</sup></h1> -->
                                    <h1 class="gray font-weight-100 mb-lg-5 pb-lg-5">Inflación <span class="bold"> {{ isMounted ?  (rgStats.inflacion.toFixed(2) || 0)  : "--" }}%</span><sup>3</sup></h1>
                                    <div>
                                        <span>
                                            1 Rendimiento neto promedio de los últimos 12 meses. <router-link :to="{ name: 'yieldPage' }" class="rg-a">Conoce más.</router-link>
                                            <br>
                                            2 Promedio CETES 28 días, últimos 12 meses. Fuente: Banxico.
                                            <br>
                                            3 INPC subyacente anual, últimos 12 meses. Fuente: Banxico.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    name: "Portfolio",
    props: ["rgStats", "isMounted"],
    components: {
        VueApexCharts
    },
    data () {
        return {
            series: [{
                data: [0,0,0]
            }],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'bar',
                    events: {
                        click: function (chart, w, e) {
                            // console.log(chart, w, e)
                        }
                    }
                },
                colors: ["#28DE18", "#3B3A3E", "#9a9fad"],
                plotOptions: {
                    bar: {
                        columnWidth: '45%',
                        distributed: true,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                xaxis: {
                    categories: [
                        ['RedGirasol'],
                        ['CETES'],
                        ["Inflación"],
                    ],
                    labels: {
                        style: {
                            colors: ["#28DE18"],
                            fontSize: '12px'
                        },
                    }
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                           return val+ "%"
                        }
                    }
                }
            },
            banxicoUrl: "https://www.banxico.org.mx/tipcamb/main.do?page=inf&idioma=sp"
        }
    },
    computed: {
        getSeries() {
            if(this.isMounted) {
                return [{
                    data: [this.rgStats.net_yield, this.rgStats.cetes, this.rgStats.inflacion]
                }]
            } else {
                return [];
            }
        }
    },
    mounted() {
        if(this.rgStats) {
            this.series = [{
                data: [this.rgStats.net_yield, this.rgStats.cetes, this.rgStats.inflacion]
            }];
            this.graphIsMounted = true;
        }
    }
}

</script>

<style scoped>
/* .chart-data {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
} */

    /* .chart-data li {
        display: flex;
    } */
/* .chip {
    width: 3rem;
    height: 0.9rem;
    border-radius: 10px;
    margin-right: 0.5rem;
    margin-top: 5px;
}

.chip.is-rg {
    border-radius: 10px 0px 10px 0px !important;
    background-color: var(--color-primary);
} */

sup {
    font-size: 2rem;
    top: -1.5em;
}
</style>